import { Track } from "../../types/game/track";

export const getTracksName = (tracks: Track[]): string =>
  tracks.map((track) => track.name).join(" / ");
